import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { object } from 'prop-types';
import DateTime from '../../../../components/DateTime/DateTime';
import TicketsStatus from '../../../../components/Tickets/TicketsStatus';

const propTypes = {
  ticket: object.isRequired,
};
const defaultProps = {
  ticket: {},
};

const TicketsListItem = ({ ticket, theme }) => (
  <tr>
    <td>{ticket.id}</td>
    <td>
      <Link to={`/tickets/${ticket.id}`} className={cn({ 'font-weight-bold': !ticket.isRead })}>
        {ticket.title ? ticket.title : `Ticket #${ticket.id}`}
      </Link>
    </td>
    <td>{ticket.answers}</td>
    <td>
      <TicketsStatus status={ticket.status} isRead={ticket.isRead} />
    </td>
    <td>
      <DateTime withDateTime timestamp={ticket.created} />
    </td>
  </tr>
);

TicketsListItem.propTypes = propTypes;
TicketsListItem.defaultProps = defaultProps;

export default TicketsListItem;
